<template>
    <div>
        <el-tabs v-model="query.approveStatus" @tab-click="search">
            <el-tab-pane label="待审核" name="0"></el-tab-pane>
            <el-tab-pane label="已通过" name="1"></el-tab-pane>
            <el-tab-pane label="未通过" name="2"></el-tab-pane>
        </el-tabs>
        <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery" :filter="false"
            style="margin-top: -15px;">
            <template slot="columns">
                <el-table-column label="ID" align="center" prop="id" />
                <el-table-column label="标题" align="center" prop="name" />
                <el-table-column label="封面" align="center">
                    <template slot-scope="{ row }">
                        <img :src="row.coverUrl" style="height: 40px;" />
                    </template>
                </el-table-column>
                <el-table-column label="设备" align="center" prop="productName" />
                <el-table-column label="电池" align="center" prop="batteryName" />
                <el-table-column label="站点" align="center" prop="siteName" />
                <el-table-column v-if="query.approveStatus == 1" label="点赞量" align="center" prop="likeCount" />
                <el-table-column v-if="query.approveStatus == 1" label="分类" align="center" prop="categoryName" />
                <el-table-column v-if="query.approveStatus == 1" label="通过时间" align="center">
                    <template slot-scope="{ row }">
                        {{ formatDate(row.approveTime) }}
                    </template>
                </el-table-column>
                <el-table-column v-if="query.approveStatus == 1" label="状态" align="center" prop="shelfStatus">
                    <template slot-scope="{ row }">
                        <el-tag type="info" v-if="row.shelfStatus === 0">未上架</el-tag>
                        <el-tag type="success" v-if="row.shelfStatus === 1">已上架</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="180">
                    <template slot-scope="{ row }">
                        <el-link v-if="query.approveStatus == 0" style="margin-right: 10px" :underline="false"
                            type="primary" @click="handleApprove(row, 1)">
                            通过
                        </el-link>
                        <el-link v-if="query.approveStatus == 0" :underline="false" type="danger"
                            @click="handleApprove(row, 2)">
                            拒绝
                        </el-link>
                        <el-link v-if="query.approveStatus == 1" :underline="false" type="primary"
                            @click="handleUpdate(row)">
                            {{ row.shelfStatus == 0 ? '上架' : '下架' }}
                        </el-link>
                        <el-link v-if="query.approveStatus == 2" :underline="false" type="primary"
                            @click="handleApprove(row, 1)">
                            重新通过
                        </el-link>
                        <el-link :underline="false" type="primary" @click="handleDetail(row)"
                            style="margin-left: 10px;">
                            查看详情
                        </el-link>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
    </div>
</template>

<script>
import { page, approve, update } from "@/api/solution";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                approveStatus: '0',
            },
            countries: []
        };
    },
    mixins: [listMixin],
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query
            };
            page(params).then(({ code, data, message }) => {
                if (code == 200) {
                    this.tableData = data.records;
                    this.total = data.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleApprove(row, status) {
            approve({ id: row.id, approveStatus: status }).then(({ code, message }) => {
                if (code == 200) {
                    this.$message.success('操作成功');
                    this.search()
                } else {
                    this.$message.error(message);
                }
            })
        },
        handleUpdate(row) {
            update({ id: row.id, shelfStatus: row.shelfStatus == 0 ? 1 : 0 }).then(({ code, message }) => {
                if (code == 200) {
                    this.$message.success('操作成功');
                    this.search()
                } else {
                    this.$message.error(message);
                }
            })
        },
        handleDetail(row) {
            this.$router.push({ path: '/solution/form', query: { id: row.id } })
        }
    },
};
</script>